import {Role} from '../../../dto/UserDto';
import {INavLink} from './typedef';

export const links: INavLink[] = [
    {
        title: 'quality_team_feedback',
        name: 'Quality Team Feedback',
        url: '/',
        exact: true,
        roles: [Role.USER]
    },
    {
        title: 'feedback_consolidation',
        name: 'Feedback Consolidation',
        url: '/feedback-consolidation',
        roles: [Role.MANAGER]
    },
    {
        title: 'feedback_overview',
        name: 'Feedback Overview',
        url: '/feedback-overview',
        roles: [Role.USER]
    },
    {
        title: 'settings',
        name: 'Settings',
        url: '/settings',
        exact: true,
        roles: [Role.ADMIN, Role.MANAGER]
    },
    {
        title: 'admin',
        name: 'Admin',
        url: '/admin',
        roles: [Role.ADMIN]
    }
    // {
    //     title: 'employees',
    //     name: 'Employees',
    //     url: '/employees',
    //     roles: [Role.USER]
    // },
];
